import { notification } from 'antd';
import axios from 'axios';
import Cookies from 'js-cookie';
import { getLangValue, localize } from '../helpers';
import captchaTokenService from '/react4xp/services/captcha-token-service';

declare module 'axios' {
    export interface AxiosRequestConfig {
        skipErrorNotification?: boolean;
    }
}

let n = true;

type TranslateParams = {
    data: string;
    code?: any;
    payload?: string;
};

const AxiosInterceptor = ({
      children,
      translations,
      isError,
      token,
      hideNoDataNotification,
      language,
  }) => {
    const translate = ({ data, code, payload }: TranslateParams): string => {
        const ltr = localStorage.getItem('translations');
        const translations = ltr && JSON.parse(ltr);

        return localize(data, translations, code, payload);
    };

    if (typeof window.localStorage !== 'undefined') {
        const ltr = localStorage.getItem('translations');
        const prevTr = ltr && JSON.parse(ltr);

        localStorage.setItem('translations', JSON.stringify({ ...prevTr, ...translations }));
    }

    if (n) {
        axios.interceptors.request.use(
            (config) => {
                const breadcrumbs = localStorage.getItem('breadcrumbs');
                const recaptchaToken = captchaTokenService.getRecaptchaToken();

                if (token) {
                    config.headers['Authorization'] = token;
                }

                if (language) {
                    config.headers['X-Portal-Language'] = getLangValue(language);
                }

                if (breadcrumbs) {
                    config.headers['Breadcrumbs'] = breadcrumbs;
                }

                if (!config.headers['recaptchaToken'] && recaptchaToken) {
                    config.headers['recaptchaToken'] = recaptchaToken;
                }

                return config;
            },
            (error) => {
                Promise.reject(error);
            }
        );

        const getNomadError = (data: any) => {
            const { nomadErrorCode, nomadErrorMessage } = data;

            switch (nomadErrorCode) {
                case '7':
                    notification['error']({
                        message: translate({ data: 'error' }),
                        description: translate({ data: 'error.nomad-error-7' }),
                    });
                    break;
                default:
                    notification['error']({
                        message: translate({ data: 'error' }),
                        description: nomadErrorMessage,
                    });
            }
        };

        const getTranslatedError = (code) => {
            if (code) {
                return translate({ data: code });
            }

            return translate({ data: 'error.internal-server-error' });
        };

        const getJsonErrorFromBlob = (error) => {
            const reader = new FileReader();

            reader.addEventListener('loadend', () => {
                if (typeof reader.result === 'string') {
                    try {
                        const data = JSON.parse(reader.result);

                        notification['error']({
                            message: translate({ data: 'error' }),
                            description: translate({ data: data.message || data.errorCode }),
                        });
                    } catch (e) {}
                }
            });

            reader.readAsText(error.response.data);
        };

        axios.interceptors.response.use(
            (res) => {
                return res;
            },
            (error) => {
                if (error.config?.skipGlobalError) {
                    return Promise.reject(error);
                }
                if (error.response && !error.config?.skipErrorNotification) {
                    if (error.response.status === 400) {
                        if (error.response?.data?.message == 'error.invalid-credentials') {
                            notification['error']({
                                message: 'Ошибка авторизации.',
                                description: translate({ data: error.response?.data?.message }),
                            });
                            return Promise.reject(error);
                        }
                    }

                    if (error.response.status === 500) {
                        if (typeof error.response?.data === 'string') {
                            notification['error']({
                                message: translate({ data: 'error' }),
                                description: translate({ data: error.response.data }),
                            });
                        } else if (error.response?.data?.nomadErrorCode) {
                            getNomadError(error.response.data);
                        } else if (error.response?.data instanceof Blob) {
                            getJsonErrorFromBlob(error);
                        } else if (
                            error.response?.data?.errorCode ==
                            'error.returned-notifications.no-notifications'
                        ) {
                            notification['error']({
                                message: 'Уведомление!',
                                description: getTranslatedError(
                                    error?.response?.data?.errorMessage
                                ),
                            });
                        } else if (error.response?.data?.ru) {
                            notification['error']({
                                message: translate({ data: 'error' }),
                                description: error.response.data[language],
                            });
                        } else {
                            const { errorCode, errorMessage, message } = error.response.data;

                            notification['error']({
                                message: translate({ data: 'error' }),
                                description: getTranslatedError(
                                    errorCode || errorMessage || message
                                ),
                            });
                        }
                    } else if (error.response.data && error.response.data instanceof ArrayBuffer) {
                        const { status, statusText, data } = error.response;
                        const message = [status, statusText].filter(Boolean).join(' - ');

                        const decoder = new TextDecoder('utf-8');
                        const description = decoder.decode(new Uint8Array(data));

                        notification['error']({
                            message,
                            description: translate({ data: description }),
                        });
                    } else if (error.response.data && error.response.data instanceof Blob) {
                        getJsonErrorFromBlob(error);
                    } else if (isError) {
                        if (error.response.status === 401 && token) {
                            Cookies.remove('token');
                            Cookies.remove('refresh_token');
                            open(
                                '/site/ru/master/isna-portal-cms/_/idprovider/jwt/logout',
                                '_self'
                            );
                            // notification['error']({
                            //     message: translate({ data: 'error.user-inactive-15-min' }),
                            //     description: translate({ data: 'error.need-re-log' }),
                            // });
                        } else if (error.response.status === 403) {
                            notification['warning']({
                                message: 'Доступ запрещен!',
                                description:
                                    'Доступ к запрашиваемому действию ограничен. ' +
                                    'Пожалуйста, свяжитесь с администратором системы ' +
                                    'для получения соответствующих прав доступа.',
                            });
                        } else if (error.response.status === 409) {
                            notification['error']({
                                message: translate({ data: 'error' }),
                                description: translate({ data: error.response.data }),
                            });
                        } else if (error.response.status === 404) {
                            if (
                                error.response.config?.url ===
                                '/services/isnaportal/open-api/taxpayer-data'
                            ) {
                                notification['error']({
                                    message: translate({ data: 'error' }),
                                    description: translate({
                                        data: 'error.false-deals-admin.taxpayer-not-found',
                                    }),
                                });
                            }
                        } else if (Array.isArray(error.response.data)) {
                            error.response.data.forEach((x) => {
                                notification['error']({
                                    message: translate({ data: 'error' }),
                                    description: translate({
                                        data: x.message,
                                        code: { 0: x.code },
                                    }),
                                });
                            });
                        } else {
                            if (!hideNoDataNotification) {
                                const taxpayerCodeMatch = (
                                    error.response.data.errorMessage || ''
                                ).match(/taxpayerCode=(\d+)/);
                                let taxpayerCode = '';

                                if (taxpayerCodeMatch) {
                                    taxpayerCode = taxpayerCodeMatch[1];
                                }

                                notification['error']({
                                    message: `${error.response.status} ${
                                        error.response.statusText &&
                                        '- ' + error.response.statusText
                                    }`,
                                    description:
                                        error.response.data && error.response.data.errorCode
                                            ? (error.response.data.params
                                                ? error.response.data.params.filename + ': '
                                                : '') +
                                            translate({
                                                data: error.response.data.errorCode,
                                                payload: taxpayerCode,
                                            })
                                            : error.response.data &&
                                            error.response.data.errorMessage
                                                ? translate({
                                                    data: error.response.data.errorMessage,
                                                    payload: taxpayerCode,
                                                })
                                                : translate({
                                                    data:
                                                        typeof error.response.data === 'string'
                                                            ? error.response.data
                                                            : error.response.data.message ||
                                                            error.response.data.body ||
                                                            JSON.stringify(error.response.data),
                                                }),
                                });
                            }
                        }
                    }
                }

                return Promise.reject(error);
            }
        );

        n = false;
    }

    return children;
};

export default AxiosInterceptor;
